import React, { useCallback, useEffect, useState } from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { Channel } from 'shared/types/channel';
import { useChannelContext } from 'context/channel';
import StoresList from './stores-list';

export interface StoreFinderProps {
  height?: string;
}

const StoreFinder: React.FC<StoreFinderProps> = ({ height }) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyD9S7q_peOXGfsR3M4zmvJ-wimo0d87v7Q', //mapsKey,
  });

  const {
    selectedChannel,
    setSelectedChannel,
    isChannelFinderOpen,
    channels,
    channelsLoading,
    channelFinderDetailChannel,
    setChannelFinderDetailChannel,
  } = useChannelContext();

  const [map, setMap] = useState<google.maps.Map | null>(null);

  const channelsToWorkWith = channels.filter((channel) => channel.geoLocation !== undefined);

  const channelPositions: google.maps.LatLngLiteral[] = [];

  const getChannelGeolocation = (channel: Channel): google.maps.LatLngLiteral | undefined => {
    if (!channel.geoLocation || !channel.geoLocation.coordinates || channel.geoLocation.coordinates.length < 2) {
      return undefined;
    }
    
    // GeoJSON coordinates are [longitude, latitude]
    const [lng, lat] = channel.geoLocation.coordinates;
    return { lat, lng };
  };

  useEffect(() => {
    if (map && isChannelFinderOpen && channelFinderDetailChannel && getChannelGeolocation(channelFinderDetailChannel) && isLoaded) {
      const position = getChannelGeolocation(channelFinderDetailChannel);
      map.setZoom(18);
      // @ts-ignore
      map.panTo(position);
    }
  }, [channelFinderDetailChannel, isLoaded, map, isChannelFinderOpen]);

  useEffect(() => {
    if (isLoaded && map) {
      const bounds = new google.maps.LatLngBounds();
      channelPositions.map((pos) => bounds.extend(pos));

      map.fitBounds(bounds, 50);
    }
  }, [map]);

  const containerStyle = {
    width: '100%',
    height: height ?? '800px',
  };

  const onLoad = useCallback((map: google.maps.Map) => {
    setMap(map);
  }, []);

  const onUnmount = useCallback(() => {
    setMap(null);
  }, []);

  const channelSelectedDetails = (channel: Channel) => {
    setChannelFinderDetailChannel(channel);
  };

  const closeDetails = () => {
    setChannelFinderDetailChannel(undefined);
    if (isLoaded && map) {
      const bounds = new google.maps.LatLngBounds();
      channelPositions.map((pos) => bounds.extend(pos));

      map.fitBounds(bounds, 50);
    }
  };

  return isLoaded && !channelsLoading ? (
    <GoogleMap mapContainerStyle={containerStyle} onLoad={onLoad} onUnmount={onUnmount}>
      {/* Child components, such as markers, info windows, etc. */}
      {channelsToWorkWith?.map((channel: Channel) => {
        const channelPosition = getChannelGeolocation(channel);
        if (!channelPosition) {
          return null;
        }

        channelPositions.push(channelPosition);

        return (
          <Marker
            key={channel.channelId}
            position={channelPosition}
            clickable={true}
            title={channel.name}
            onClick={() => {
              setChannelFinderDetailChannel(channel);
            }}
          />
        );
      })}
      <div
        style={{
          position: 'absolute',
          width: '22%',
          height: 'auto',
          overflowY: 'scroll',
          top: '5%',
          right: '5%',
          backgroundColor: 'white',
        }}
        className="rounded shadow-lg"
      >
        <StoresList
          channels={channelsToWorkWith}
          detailChannel={channelFinderDetailChannel}
          openDetailsFor={channelSelectedDetails}
          closeDetails={closeDetails}
          setSelectedChannel={setSelectedChannel}
          selectedChannel={selectedChannel}
        />
      </div>
    </GoogleMap>
  ) : (
    <></>
  );
};

export default StoreFinder;
